import { NotificationMessage } from '@gravitate-js/excalibrr'
import api from '@utils/api'

export const handleSubmit = async (formData, selectedRows) => {
  let overrideValuesEntered = false
  let splitEntered = false

  Object.keys(formData).forEach((k) => {
    if (formData[k]) {
      if (k !== 'is_split_me') overrideValuesEntered = true
      else splitEntered = true
    }
  })

  if (!overrideValuesEntered && !splitEntered) {
    NotificationMessage('Oops!', 'Please enter at least one value to override.')
    return
  }

  const keys = []
  selectedRows.forEach((r) => {
    keys.push(r.key)
  })

  if (overrideValuesEntered) {
    const tankOverride = {}
    tankOverride.tank_keys = keys
    tankOverride.inventory_strategy = formData.inventory_strategy
    tankOverride.target_min = parseFloat(formData.target_min)
    tankOverride.target_max = parseFloat(formData.target_max)
    tankOverride.minimum_load_size = parseFloat(formData.minimum_load_size)
    tankOverride.maximum_load_size = parseFloat(formData.maximum_load_size)
    tankOverride.load_tags = formData.load_tags
    tankOverride.demand_model_tank_profile = formData.demand_model_tank_profile
    await api.overrideTankStrategies(tankOverride)
  }

  if (splitEntered) {
    const tankSplit = {}
    tankSplit.tank_keys = keys
    tankSplit.split_me = formData.is_split_me === 'Yes'
    await api.setTankStrategySplits(tankSplit)
  }
}

export const handleRemove = (selectedRows, triggerRefresh, setLoading) => {
  setLoading(true)

  const overiddesToRemove = []
  selectedRows.forEach((r) => {
    if (r.is_overridden) overiddesToRemove.push(r.key)
  })

  api.removeTankStrategies(overiddesToRemove).then(() => {
    triggerRefresh()
    setLoading(false)
  })
}
